// sort(compare).reverse()

export function compare(a, b) {
  if (a.activeStatus < b.activeStatus) return -1;
  if (a.activeStatus > b.activeStatus) return 1;
  return 0;
}
